module.exports = __webpack_public_path__ + "media/images/front/services/coordination-32bc0d5ecc5e67a897a64c5f12a966ad.jpg";